import * as moment from 'moment';
import { Moment } from 'moment';
import Company from 'src/entities/Company';
import ProjectImage from 'src/entities/ProjectImage';
import ProjectDocument from 'src/entities/ProjectDocument';
import ProjectTeamMembers from 'src/value-objects/ProjectTeamMembers';
import OfflineInvestor from 'src/entities/OfflineInvestor';
import Investment from 'src/entities/Investment';

export default class Project {
  id: number;
  cashTarget: number;
  startDate: Moment;
  endDate: Moment;
  cash: number;
  capital: string;
  numberInvestors: number;
  company: Company;
  ticketValue: number;
  premoneyValuation: number;
  coInvestorsInvest: number;
  equity: number;
  sharePercentage: number;
  interested: number;
  description: string;
  images: ProjectImage[];
  offlineInvestors: OfflineInvestor[];
  metrics: string;
  goToMarketDescription: string;
  goToMarketImage?: ProjectImage;
  syndicateAgreement?: string;
  syndicateAgreementImage?: ProjectImage;
  stakeholderAgreement?: string;
  stakeholderAgreementImage?: ProjectImage;
  roundDetails: string;
  highlightInvestorName?: string;
  highlightInvestorDescription?: string;
  highlightInvestorImage?: ProjectImage;
  environmentDescription: string;
  environmentImage?: ProjectImage;
  documents: ProjectDocument[];
  teamMembers: ProjectTeamMembers[];
  invested: Investment[];
  status?: string;
  marketData?: string;
  dueDiligenceReport?: string;
  dueDiligenceStatus: string;
  activePayment: boolean;
  formalizationStatus: string;

  constructor(entity: Project) {
    this.id = entity.id;
    this.cashTarget = entity.cashTarget;
    this.startDate = moment.utc(entity.startDate);
    this.endDate = moment.utc(entity.endDate);
    this.cash = entity.cash;
    this.capital = entity.capital;
    this.numberInvestors = entity.numberInvestors;
    this.company = new Company(entity.company);
    this.ticketValue = entity.ticketValue;
    this.premoneyValuation = entity.premoneyValuation;
    this.coInvestorsInvest = entity.coInvestorsInvest;
    this.equity = entity.equity;
    this.sharePercentage = entity.sharePercentage;
    this.interested = entity.interested;
    this.description = entity.description;
    this.images = entity.images.map((image) => new ProjectImage(image));
    this.offlineInvestors = entity.offlineInvestors.map((offlineInvestor) => new OfflineInvestor(offlineInvestor));
    this.description = entity.description;
    this.metrics = entity.metrics;
    this.goToMarketDescription = entity.goToMarketDescription;
    this.goToMarketImage = entity.goToMarketImage ? new ProjectImage(entity.goToMarketImage) : undefined;
    this.syndicateAgreement = entity.syndicateAgreement || undefined;
    this.syndicateAgreementImage = entity.syndicateAgreementImage ?
      new ProjectImage(entity.syndicateAgreementImage) : undefined;
    this.stakeholderAgreement = entity.stakeholderAgreement || undefined;
    this.stakeholderAgreementImage = entity.stakeholderAgreementImage ?
      new ProjectImage(entity.stakeholderAgreementImage) : undefined;
    this.roundDetails = entity.roundDetails;
    this.highlightInvestorName = entity.highlightInvestorName || undefined;
    this.highlightInvestorDescription = entity.highlightInvestorDescription || undefined;
    this.highlightInvestorImage = entity.highlightInvestorImage ?
      new ProjectImage(entity.highlightInvestorImage) : undefined;
    this.environmentDescription = entity.environmentDescription;
    this.environmentImage = entity.environmentImage ? new ProjectImage(entity.environmentImage) : undefined;
    this.documents = entity.documents.map(document => new ProjectDocument(document));
    this.teamMembers = entity.teamMembers.map((teamMember) => new ProjectTeamMembers(teamMember));
    this.invested = entity.invested ? entity.invested.map(investment => new Investment(investment)) : [];
    this.status = entity.status;
    this.marketData = entity.marketData || '';
    this.dueDiligenceReport = entity.dueDiligenceReport || '';
    this.dueDiligenceStatus = entity.dueDiligenceStatus;
    this.activePayment = entity.activePayment || false;
    this.formalizationStatus = entity.formalizationStatus || '';
  }
}



// WEBPACK FOOTER //
// ./src/entities/Project.tsx